import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const VerifyEmailModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "VerifyEmailModalContainer" */
      './VerifyEmailModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
